import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Vaga } from './vaga.model';
import { Observable } from 'rxjs';
import { AppFilter } from "app/models/app-filter.model";
import { AbVaga } from 'app/abstract/full-pages/vaga/vaga.abstract';


@Injectable({
  providedIn: 'root'
})
export class VagaService extends AbVaga {

  constructor(http: HttpClient) {
    super(http);
  }

  public getVagas() {
    return this.get("vagas/all/");
  }

  public getAllVagas(filter: AppFilter): Observable<any> {
    return this.get(`vagas/filter_vagas_estacionamento/${filter.encode()}`);
  }

  public getAllVagasPage(filter: AppFilter): Observable<any> {
    return this.get(`vagas/filter_vagas_estacionamento_page/${filter.encode()}`);
  }

  public saveVaga(vaga: Vaga): Observable<any> {
    return this.save("vagas/", vaga);
  }

  public saveVagas(vagas: Array<Vaga>): Observable<any> {
    return this.save("vagas/save_vagas/", vagas);
  }

  public desativar(id: number) {
    return this.delete("vagas/desativar/", id);
  }

  public getVagasByUnidade(filter: AppFilter): Observable<any> {
    return this.get(`vagas/vagas_unidade/${filter.encode()}`);
  }

  public getAllVagasAtivas() {
    return this.get("vagas/all/");
  }

  public getAllVagasAtivasDeVisitantes() {
    return this.get("vagas/tipo_visitante/");
  }

}